import { ThemeType } from '../../types/themeType';

export const toggleTheme = (data: ThemeType) => ({
  type: data.type,
  payload: data.payload,
});
